import { Drawer, Toolbar, Box, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { TABS } from './FreelanceDriverTabsList';
import { includes } from 'lodash';
import { DrawerList, DrawerCurrentUserStatus, DrawerAccountWelcome } from '../components';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
const drawerWidth = 260;
export default function FreelanceDriverDrawer({ openDrawer, toggleDrawer }) {
    const { pathname } = useLocation();
    const { currentStatus, companyName, logo } = useSelector((state) => {
        if (!state.entities.profile.profile) {
            return { role: null, currentStatus: null, companyName: null, logo: null, shippingType: null }
        }
        return state.entities.profile.profile
    });
    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));
    useEffect(() => {
        if (downLg && openDrawer) {
            toggleDrawer();
        }
    }, [pathname, downLg]);

    return (
        <Drawer
            open={openDrawer}
            onClose={toggleDrawer}
            variant={downLg ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <DrawerAccountWelcome companyName={companyName} logo={logo}  />
                {/* {
                    !!currentStatus && includes(["BLOCKED", "WAITING", "ORDER_PLAN_SELECTED"], currentStatus) &&
                    <DrawerCurrentUserStatus currentStatus={currentStatus} />
                } */}
                <DrawerList tabs={TABS} />
            </Box>
        </Drawer>
    )
}